import { useQuery } from '@tanstack/react-query';
import React from 'react';
import type { TimeCardShift } from '../../../../../js/api';
import { AssignmentsService } from '../../../../../js/api';
import { ActivityLog } from '../../../components/activity-log';
import { Dialog, DialogBody, DialogCloseButton, DialogTitle } from '../../../components/dialog';
import type { ActivityHistory } from '../../../utils/activity-types';
import { formatDateTimeRange } from '../../../utils/date';
import { TIMECARD_SHIFT_CHANGE_HISTORY_QUERY_KEY } from './queryKeys';

export const ShiftHistoryModal: React.FC<{
  open: boolean;
  onClose: () => void;
  shift?: TimeCardShift;
}> = ({ open, onClose, shift }) => {
  const { data: changeHistory } = useQuery({
    queryKey: [TIMECARD_SHIFT_CHANGE_HISTORY_QUERY_KEY, shift?.id],
    queryFn: () =>
      AssignmentsService.assignmentsTimecardShiftChangeHistoryRetrieve({
        id: shift!.id,
        sort: 'desc',
      }),
    enabled: !!shift?.id && open,
  });

  const shiftDate = shift ? formatDateTimeRange(shift) : '';

  return (
    <Dialog open={open} onClose={onClose} size="lg">
      <div className="tw:flex tw:items-start tw:justify-between">
        <DialogTitle>
          <>
            Shift History
            {shiftDate && (
              <div className="tw:text-xs tw:text-zinc-500 tw:font-normal">{shiftDate}</div>
            )}
          </>
        </DialogTitle>
        <DialogCloseButton onClick={onClose} />
      </div>
      <DialogBody>
        <ActivityLog
          enableUpdatesFilter={true}
          changeHistory={changeHistory as ActivityHistory[] | undefined}
        />
      </DialogBody>
    </Dialog>
  );
};
